const { GATSBY_BLOG_PUBLIC_URL_BASE: blogPublicBaseUrl } = process.env;

export const blogConfig = {
  blogPublicBaseUrl,
};
